import { render } from "./Currencies.vue?vue&type=template&id=31fff840&scoped=true"
import script from "./Currencies.vue?vue&type=script&lang=js"
export * from "./Currencies.vue?vue&type=script&lang=js"

import "./Currencies.vue?vue&type=style&index=0&id=31fff840&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31fff840"]])

export default __exports__